import ReactCreditCard from '../../ReactCreditCard';
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import {
  Container,
  Title,
  ContainerCreate,
  ContainerCardCredit,
  ContainerFormCardCredit,
  FormCardCreditBox,
  FormCardCreditBoxBTNCanc,
  FormCardCreditBoxBTN,
} from './styles';
import Button from '../../Button';
import { useTranslation } from '../../../hooks/useTranslation';
import { bValidExpiration } from '../../../utils/bValidExpirationMethod';
import {
  UserCard,
  ReactCreditCardProps,
} from '../../../store/modules/auth/types';
import { useDispatch, useSelector } from 'react-redux';
import { methodCreated } from '../../../store/modules/parameter/actions';
import getValidationErrors from '../../../utils/getValidationErrors';
import { StoreState } from '../../../store/createStore';
import Input from '../../Input';
import { bValidCpf } from '../../../utils/bValidCpf';
import { MethodsProps } from '../../../store/modules/parameter/types';

interface SubmitProps {
  id: number;
  number: string;
  expiration: string;
  name: string;
  cvc: string;
  customer_doc: string;
  cardLastFour: string;
  type: string;
}

interface PaymentCreateProps {
  onSetOpenViewCreatePayment: () => void;
  handledSetMethod: (methodSel: MethodsProps) => void;
  valueId?: number;
  methodSelected: MethodsProps;
  valuesEdit: SubmitProps;
}

const filterCard = '************';

const PaymentCreate: React.FC<PaymentCreateProps> = ({
  onSetOpenViewCreatePayment,
  handledSetMethod,
  methodSelected,
  valuesEdit,
}: PaymentCreateProps) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState<ReactCreditCardProps>(valuesEdit);
  const [focused, setFocus] = useState<string | undefined>(undefined);
  const formRef = useRef<FormHandles>(null);
  const {
    user: {
      data: { cpf_cnpj, id },
    },
  } = useSelector((state: StoreState) => state.auth);
  const { onTranslation: t } = useTranslation();

  const handledSubmit = useCallback(
    async (data: SubmitProps) => {
      try {
        const schema = Yup.object().shape({
          number: Yup.string()
            .required(`${t('main.messages_yup.last_name_required')}`),
          expiration: Yup.string()
            .required(`${t('main.messages_yup.last_name_required')}`)
            .test({
              test: value => bValidExpiration(value as string),
              message: `${t('main.messages_yup.expiration_card_invalid')}`,
            }),
          name: Yup.string().required(
            `${t('main.messages_yup.name_required')}`,
          ),
          
          // cvc: Yup.string()
          //   .transform((value: string) => {
          //     return value.split(/\D/).join('');
          //   })
          //   .when(['valueEdit'], {
          //     is: true,
          //     then: Yup.string().required(
          //       `${t('main.messages_yup.cvc_card_required')}`,
          //     ),
          //   }),
          customer_doc: Yup.string().transform((value: string) => {
            return value.split(/\D/).join('')
          })
            .test({
              test: cpf_cnpj => bValidCpf(cpf_cnpj),
              message: t('main.messages_yup.cpf_invalid')
            }).test({
              test: cpf_cnpj => !isNaN(cpf_cnpj),
              message: t('main.messages_yup.write_only_number')
            }).required(t('main.messages_yup.cpf_required'))
        });

        await schema.validate(
          {
            ...data,
            ...(values.id > 0 ? {
              valueEdit: false,
              number: valuesEdit.number,
            }: {
              valueEdit: true,
            })
          },
          {
            abortEarly: false,
          },
        );
        if ((valuesEdit.number || data.number)  && data.expiration && data.name) {
          const cardPayload: UserCard = {
            ...(valuesEdit.id > 0 ? {
              id: valuesEdit.id,
              card_number: valuesEdit.number,
              card_last_four: valuesEdit.cardLastFour,
              customer_doc: valuesEdit.customer_doc.replace(/\D/g, ''),
            } : {
              id: 0,
              card_number: data.number.replace(/\D/g, ''),
              card_last_four: data.number
                .replace(/\D/g, '')
                .slice(-4),
            }),
            expiry_date: data.expiration, // data.expiration.split(/\D/).join(''),
            full_name: data.name,
            customer_doc: data.customer_doc.replace(/\D/g, ''),
            card_brand: '',
            authorizer_id: '2',
            merchant_usn: id || '',
            customer_id: cpf_cnpj?.split(/\D/).join('') || '',
          };
          dispatch(methodCreated(methodSelected, cardPayload));
          onSetOpenViewCreatePayment();
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          //konsole.log('handleSubmit errors:', errors);
        }
      }
    },
    [
      methodSelected,
      cpf_cnpj,
      dispatch,
      id,
      valuesEdit,
      onSetOpenViewCreatePayment,
      values.id,
      t,
    ],
  );

  const handledFocus = useCallback(
    event => setFocus(event.target.name as string),
    [setFocus],
  );

  const handledBlur = () => setFocus(undefined);

  const handledChange = useCallback(
    event => {
      let valueStr = '';
      const { name, value } = event.target;
      switch (name) {
        case 'number': {
          valueStr = value.replace(/\D/g, '');
          break;
        }
        default: {
          valueStr = value;
        }
      }
      setValues(v => ({ ...v, [name]: valueStr }));
    },
    [setValues],
  );

  const handledBack = useCallback(() => {
    handledSetMethod({} as MethodsProps);
    onSetOpenViewCreatePayment();
  }, [handledSetMethod, onSetOpenViewCreatePayment]);

  useEffect(() => {
    if (formRef.current && valuesEdit.name) {
      //konsole.log('carrega...', address);
      formRef.current.setData({
        name: valuesEdit.name,
        expiration: valuesEdit.expiration,
        number: valuesEdit.number,
        cvc: valuesEdit.cvc,
        customer_doc: valuesEdit.customer_doc,
        cardLastFour: (filterCard + valuesEdit.cardLastFour)
      });
    } else if (formRef.current) {
        formRef.current.setData({
          name: ''
        })
      }
  }, [valuesEdit]);

  return (
    <Container>
      <Title>
        <span>
          {valuesEdit.id > 0
            ? `${t('main.component_account_payment.payment_create.edit_card')}`
            : `${t(
                'main.component_account_payment.payment_create.add_new_card',
              )}`}
        </span>
      </Title>
      <ContainerCreate>
        <ContainerCardCredit>
          <ReactCreditCard
            {
              ...values
            }
            number={valuesEdit.id > 0 ? filterCard + values.cardLastFour : values.number}
            {
              ...(valuesEdit.id > 0 ? ({
                type: valuesEdit.type,
              }) : {})
            }
            focused={focused}

            placeholderName={`${t(
              'main.component_account_payment.payment_create.cardholder_name',
            )}`}
          />
        </ContainerCardCredit>
        <ContainerFormCardCredit>
          <Form
            // initialData={{ postcode: '06422070' }}
            ref={formRef}
            onSubmit={handledSubmit}
          >
            <FormCardCreditBox>
              <Input
                mask="####.####.####.####"
                name={valuesEdit.id > 0 ? 'cardLastFour' : 'number'}
                textLabel={`${t(
                  'main.component_account_payment.payment_create.input_numero',
                )}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
                handledInputBlurExt={handledBlur}
                handledInputFocusExt={handledFocus}
                onChangeExt={handledChange}
                disabled={valuesEdit.id > 0 ? true : false}
              />
            </FormCardCreditBox>
            <FormCardCreditBox>
              <Input
                name="name"
                textLabel={`${t(
                  'main.component_account_payment.payment_create.input_name',
                )}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
                handledInputBlurExt={handledBlur}
                handledInputFocusExt={handledFocus}
                onChangeExt={handledChange}
              />
            </FormCardCreditBox>
            <FormCardCreditBox bDirectionColumn>
              <Input
                mask="##/##"
                name="expiration"
                textLabel={`${t(
                  'main.component_account_payment.payment_create.input_expiration',
                )}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
                handledInputBlurExt={handledBlur}
                handledInputFocusExt={handledFocus}
                onChangeExt={handledChange}
              />
              <Input
                mask="###.###.###-##"
                name="customer_doc"
                textLabel={`${t(
                  'main.component_account_payment.payment_create.input_cpf',
                )}`}
                Border="1px solid var(--primary)"
                formRef={formRef}
                handledInputBlurExt={handledBlur}
                handledInputFocusExt={handledFocus}
                onChangeExt={handledChange}
              />
            </FormCardCreditBox>
            <FormCardCreditBox justifyContent="flex-end">
              <FormCardCreditBoxBTNCanc onClick={handledBack}>
                <span>{t('main.globals.back')}</span>
              </FormCardCreditBoxBTNCanc>
              <FormCardCreditBoxBTN>
                <Button
                  button={{ type: 'submit' }}
                  atributes={{
                    buttonType: 'success',
                    textColor: '#fff',
                    textSize: '18px',
                  }}
                >
                  {/* {loading || loadingCheckout ? (
                            <Loading color={"var(--primary)"} loading={loading} size={30} />
                        ) : (
                          <> */}
                  {t('main.globals.save')}
                  {/* </>)} */}
                </Button>
              </FormCardCreditBoxBTN>
            </FormCardCreditBox>
          </Form>
        </ContainerFormCardCredit>
      </ContainerCreate>
    </Container>
  );
};

export default PaymentCreate;
